
import { LoginSection } from 'modules';

export type LoginActivityProps = {};

/* eslint-disable-next-line @typescript-eslint/no-unused-vars */
export const LoginActivity = (props: LoginActivityProps) => {

  return (
    <LoginSection.FC />

  );
};
